module.exports = __webpack_public_path__ + "media/Video 29.7fa33ba3.mp4";